import React from "react";
import { Button } from "@mui/material";
import { CircularProgress } from "@mui/material";
interface CustomButtonProps {
  loader?: boolean;
  endIcon?: React.ReactNode;
  name: string;
  onClick?: () => void;
  variant?: "text" | "contained" | "outlined";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
}

const CustomButton: React.FC<CustomButtonProps> = ({
  loader,
  endIcon,
  name,
  onClick,
  variant = "contained",
  size = "small",
  disabled,
  fullWidth = false,
  className,
  color = "primary",
}) => {
  return (
    <Button
      style={{
        // minWidth: 80,
        minHeight: 30,
        textTransform: "none",
        background: "#114C5A",
      }}
      className={className}
      fullWidth={fullWidth}
      disabled={disabled}
      color={color}
      size={size}
      variant={variant}
      onClick={onClick}
      endIcon={
        loader ? <CircularProgress color="inherit" size={20} /> : endIcon
      }
    >
      {name}
    </Button>
  );
};

export default CustomButton;
